<template>
	<div class="color">
		<span v-for="(bin, index) in colorBins"
			v-if="bin > 0"
			:key="index"
			:style="{
				width: binWidth(bin, colorTotal),
				background: colorCode(index)
			}">
			<label :style="{ color: textColorCode(index) }">
				{{ binLabel(bin, colorTotal) }}
			</label>
		</span>
	</div>
</template>
<script>
import ExcretionAnalysis from '..'

export default {
	name: 'lifestyle-table-color-column',
	extends: ExcretionAnalysis
}
</script>

<style lang="scss" scoped>

.color {
	height: 32px;
	> span {
		position: relative;
		float: left;
		height: 12px;
		margin-top: 18px;
		opacity: 0.8;

		label {
			position: absolute;
			left: 0px;
			width: 100%;
			text-align: center;
			color: #3f3f3f;
			bottom: -6px;
			font-size: 10px;
			font-weight: 700;
			letter-spacing: 1px;
		}
	}
}
</style>
